import api from '../../services/api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getPaymentDetails = createAsyncThunk(
  'getPaymentsDetails/fetchAll',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/payments/get/${id}`,
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const searchForStudent = createAsyncThunk(
  'searchForStudent/fetchAll',
  async (searchTerm) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/searchStudent?search=${searchTerm}`,
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const deleteTransactionById = createAsyncThunk(
  'deleteTransactionById/delete',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/payments/${id}`,
        method: 'DELETE',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const transactionIdCheck = createAsyncThunk(
  'getIdCheck/fetch',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/payments/idCheck/${id}`,
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const OtherstransactionIdCheck = createAsyncThunk(
  'OtherstransactionIdCheck/fetch',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/fee-transaction/check/${id}`,
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const postPaymentDetails = createAsyncThunk(
  'postPaymentsDetails/post',
  async (paymentData,{rejectWithValue}) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/payments/`,
        method: 'POST',
        data: paymentData,
        headers: { smsService: localStorage.getItem('smsService') },
      });
      return { status: response?.status, data: response.data };
    } catch (error) {
      return rejectWithValue({ status: error?.response?.status, data: error?.response.data })
    }
  },
);
export const getOtherFeeTypes = createAsyncThunk(
  'getOtherFeeTypes/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/feetypes/`,
        method: 'GET',
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response.status,
      });
    }
  },
);
export const postOtherFeeTypes = createAsyncThunk(
  'postOtherFeeTypes',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/feetypes/`,
        method: 'POST',
        data: data,
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response.status,
      });
    }
  },
);
export const getOtherFeeTypesConfigurations = createAsyncThunk(
  'getOtherFeeTypesConfigurations/fetchAll',
  async (StudentId, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/fee-details/${StudentId}`,
        method: 'GET',
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response.status,
      });
    }
  },
);
export const postOtherFeeTypesConfigurations = createAsyncThunk(
  'postOtherFeeTypesconfigurations',
  async (details, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/fee-details/${details.StudentId}`,
        method: 'POST',
        data: details.data,
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response.status,
      });
    }
  },
);
export const postOtherFeesDetails = createAsyncThunk(
  'postOtherFeesDetails',
  async (details, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/fee-transaction/',
        method: 'POST',
        data: details,
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response.status,
      });
    }
  },
);
export const getOtherFeeDetails = createAsyncThunk(
  'getOtherFeeDetails/fetchAll',
  async (StudentId, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/fee-transaction/${StudentId}`,
        method: 'GET',
      });
      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response.status,
      });
    }
  },
);
const PaymentSlice = createSlice({
  name: 'payments',
  initialState: {
    paymentDetails: [],
    feeStrucute: [],
    status: '',
    error: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentDetails.pending, (state) => {
        state.status = 'loading';
        state.paymentDetails = [];
      })
      .addCase(getPaymentDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.paymentDetails = action.payload;
      })
      .addCase(getPaymentDetails.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.error.message;
      });
  },
});
export default PaymentSlice.reducer;
